export class PractitionerSpecialty {
  practitionerId: number;
  specialityId: number;
  specialtyCategoryId: number;
  specialtySubCategoryId: number;
  specializationCategoryId: number;
}
